import apiClient from "./apiClient";

const catalogsEndpoint = "/catalogs";

// --- FUNCIONES DE LECTURA (GET) ---

export const getAllCatalogs = async () =>
  apiClient.get(`${catalogsEndpoint}/all`).then((res) => res.data);

export const getMainImageCatalog = async () =>
  apiClient
    .get(`${catalogsEndpoint}/getImageCatalogSection`)
    .then((res) => res.data);

// --- FUNCIONES DE CREACIÓN (POST) ---

export const createCatalog = async (formData) =>
  // Asumimos que 'formData' es un objeto JSON
  apiClient
    .post(`${catalogsEndpoint}/create`, formData)
    .then((res) => res.data);

export const uploadSectionImageCatalog = async (formData) => {
  // Para subir archivos, 'formData' debe ser una instancia de FormData
  return apiClient
    .post(`${catalogsEndpoint}/uploadImageCatalogSection`, formData)
    .then((res) => res.data);
};

// --- FUNCIONES DE ACTUALIZACIÓN (PUT) ---

export const updateCatalog = async (formData, catalogId) =>
  // Asumimos que 'formData' es un objeto JSON
  apiClient
    .put(`${catalogsEndpoint}/edit/${catalogId}`, formData)
    .then((res) => res.data);

// --- FUNCIONES DE BORRADO (DELETE) ---

export const deleteCatalog = async (id) =>
  apiClient.delete(`${catalogsEndpoint}/delete/${id}`).then((res) => res.data);

export const deleteMainImageCatalogSection = async (id) =>
  apiClient
    .delete(`${catalogsEndpoint}/deleteImageCatalogSection/${id}`)
    .then((res) => res.data);
